




// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// export default function VehicleFullCard({ v }) {
//   const [mainImage, setMainImage] = useState(v.image);

//   return (
//     <div className="car-full-wrapper">

//       <h2 className="car-full-title">{v.name}</h2>

//       <div className="car-full-row">

//         {/* LEFT SIDE */}
//         <div className="car-full-left">
//           <img className="car-full-main-img" src={mainImage} alt={v.name} />

//           <div className="car-full-thumbs">
//             {(v.gallery || []).map((img, idx) => (
//               <img
//                 key={idx}
//                 src={img}
//                 className="car-full-thumb"
//                 onClick={() => setMainImage(img)}
//                 alt="thumb"
//               />
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="car-full-right">

//           <h3 className="car-spec-heading">Specifications</h3>

//           <table className="car-spec-table">
//             <tbody>
//               <tr><td>Body</td><td>{v.body}</td></tr>
//               <tr><td>Seating Capacity</td><td>{v.seats}</td></tr>
//               <tr><td>Door</td><td>{v.doors}</td></tr>
//               <tr><td>Engine</td><td>{v.engine}</td></tr>
//               <tr><td>Transmission</td><td>{v.transmission}</td></tr>
//               <tr><td>Fuel Type</td><td>{v.fuel}</td></tr>
//               <tr><td>AC</td><td>{v.ac}</td></tr>
//             </tbody>
//           </table>

//           <h3 className="car-details-heading">Details</h3>

//           <ul className="car-details-list">
//             <li>4 Hrs. / 40 Kms.</li>
//             <li>8 Hrs. / 80 Kms.</li>
//             <li>Pune airport pickup / drop.</li>
//             <li>Mumbai airport pickup / drop.</li>
//             <li>Outstation use</li>
//           </ul>

//           <Link to="/book" className="car-full-btn">Book Now</Link>
//         </div>

//       </div>
//     </div>
//   );
// }





import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaCarSide,
  FaUsers,
  FaDoorOpen,
  FaCogs,
  FaGasPump,
  FaSnowflake,
  FaExchangeAlt
} from "react-icons/fa";

export default function VehicleFullCard({ v }) {
  const [mainImage, setMainImage] = useState(v.image);

  return (
    <div className="car-full-wrapper">

      <h2 className="car-full-title">{v.name}</h2>

      <div className="car-full-row">

        {/* LEFT SIDE */}
        <div className="car-full-left">
          <img className="car-full-main-img" src={mainImage} alt={v.name} />

          <div className="car-full-thumbs">
            {(v.gallery || []).map((img, idx) => (
              <img
                key={idx}
                src={img}
                className="car-full-thumb"
                onClick={() => setMainImage(img)}
                alt="thumb"
              />
            ))}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="car-full-right">

          <h3 className="car-spec-heading">Specifications</h3>

          <table className="car-spec-table">
            <tbody>
              <tr>
                <td><FaCarSide className="spec-icon" /> Body</td>
                <td>{v.body}</td>
              </tr>

              <tr>
                <td><FaUsers className="spec-icon" /> Seating</td>
                <td>{v.seats}</td>
              </tr>

              <tr>
                <td><FaDoorOpen className="spec-icon" /> Doors</td>
                <td>{v.doors}</td>
              </tr>

              <tr>
                <td><FaCogs className="spec-icon" /> Engine</td>
                <td>{v.engine}</td>
              </tr>

              <tr>
                <td><FaExchangeAlt className="spec-icon" /> Transmission</td>
                <td>{v.transmission}</td>
              </tr>

              <tr>
                <td><FaGasPump className="spec-icon" /> Fuel Type</td>
                <td>{v.fuel}</td>
              </tr>

              <tr>
                <td><FaSnowflake className="spec-icon" /> AC</td>
                <td>{v.ac}</td>
              </tr>
            </tbody>
          </table>

          {/* <h3 className="car-details-heading">Details</h3>

          <ul className="car-details-list">
            <li>4 Hrs. / 40 Kms.</li>
            <li>8 Hrs. / 80 Kms.</li>
            <li>Pune airport pickup / drop.</li>
            <li>Mumbai airport pickup / drop.</li>
            <li>Outstation use</li>
          </ul> */}

          <Link to="/book" className="car-full-btn">Book Now</Link>
        </div>

      </div>
    </div>
  );
}
